// import { StakeholderWithCaseStakeholder } from './stakeholder-with-case-stakeholder';
// import { CoverageType } from './coverageType';

export class DropdownDictionary {
  id: any;
  name: any;

  public constructor(id?: any, name?: any) {
    this.id = id;
    this.name = name;
  }
}

// @Injectable({
//   providedIn: 'root'
// })
// export class DropdownAdapter implements Adapter<DropdownDictionary> {
//   adapt(item: string): DropdownDictionary {
//     return new DropdownDictionary(item, item);
//   }
// }
//
// @Injectable({
//   providedIn: 'root'
// })
// export class TeamDropdownAdapter implements Adapter<DropdownDictionary> {
//   adapt(item: any): DropdownDictionary {
//     return new DropdownDictionary(item.teamId, item.teamName);
//   }
// }

// @Injectable({
//   providedIn: 'root'
// })
// export class CoverageTypeDropDownAdapter implements Adapter<DropdownDictionary> {
//   adapt(item: CoverageType): DropdownDictionary {
//     return new DropdownDictionary(item.id, item.description);
//   }
// }
//
// @Injectable({
//   providedIn: 'root'
// })
// export class SupplierDropDownAdapter implements Adapter<DropdownDictionary> {
//   adapt(item: StakeholderWithCaseStakeholder): DropdownDictionary {
//     let fullName: string;
//     if (item.companyName != null && item.companyName !== '') {
//       return new DropdownDictionary(item.id.toString(), item.companyName);
//     }
//     if (item.firstName != null && item.firstName !== '') {
//       fullName = item.firstName;
//     }
//     if (item.surname != null && item.surname !== '') {
//       fullName = fullName + ' ' + item.surname;
//     }
//     return new DropdownDictionary(item.id.toString(), fullName);
//   }
//
//   adaptToIconList(item: StakeholderWithCaseStakeholder): DropdownDictionary {
//     return new DropdownDictionary(item.stakeholderType, item.imageName);
//   }
// }
